export default "__VITE_ASSET__B2b4a4fy__"